module.exports = __webpack_public_path__ + "static/python-1647295e0212900b9086fe7ce6236599.png";